// 专项培训（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">专项培训</h1>

      <div class="one">
        <div class="biaotiOne">
          <span class="blue"></span>
          <h2>工程项目培训</h2>
        </div>
        <p class="xiangqing">针对性的开展提升工程质量、安全、新技术应用、绿色施工等方面的系统培训。</p>
        <div class="left">
          <div class="oneImg">
            <img src="../../assets/img/专项培训/技术@2x.png" alt />
          </div>
          <h4>单项技术提升方面</h4>
          <p>根据企业需求为企业定制全年培训计划，对项目进行宣贯培训，指导项目部及时对BIM、新技术应用、绿色施工、工法、QC、质量标准化工地等形成成套成果，提升项目总结能力，促进企业成果转换和积累。</p>
        </div>
        <div class="right">
          <div class="twoImg">
            <img src="../../assets/img/专项培训/资料.png" alt />
          </div>
          <h4>技术资料方面</h4>
          <p>从工程准备阶段、工程实施阶段到工程资料移交，通过现场培训 、规范讲解，全方位梳理施工全过程资料整理要点。保证资料真实有效、编目清晰、具有可追溯性。</p>
        </div>
      </div>
      <div class="two"></div>
      <div class="three">
        <div class="biaotiTwo">
          <span class="blue"></span>
          <h2>行业前沿技术培训</h2>
        </div>
      </div>
      <div class="four">
        <div class="fourRight"></div>
        <div class="fourLeft">
          <p>针对当前信息技术发展的新方向、新动向，如何将信息技术有机融入建筑企业管理、工程项目管理、建造过程管理、风险管控等方面，提升企业的管理能力、决策效率和建造水平，进而提高企业经济效益和竞争力。</p>
          <p>针对建筑企业在推动装配式建筑方面的困惑，通过系统培训、专家现场指导，提供相应解决方案。</p>
        </div>
      </div>
    </div>
    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mTrain"); //移动端跳转路由
    } else {
      this.$router.replace("/train"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/专项.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .one {
      margin-left: 0.36rem;
      margin-bottom: 1.66rem;
      .biaotiOne {
        width: 100%;
        height: 1.5rem;
        position: relative;
      }
      .xiangqing {
        opacity: 1;
        font-size: 0.7rem;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: left;
        color: #231815;
        margin-bottom: 2rem;
        text-indent: 2em;
      }
      .left {
        margin: 0.82rem auto 0;
        width: 80%;
        height: 11rem;
        padding: 1.3rem 0.6rem;
        background: #ffffff;
        border: 0.03rem solid #b5b5b5;
        border-radius: 0.4rem;
        box-sizing: border-box;
        position: relative;
        .oneImg {
          width: 2rem;
          height: 2rem;
          line-height: 2.4rem;
          text-align: center;
          position: absolute;
          top: -1rem;
          left: 5.8rem;
          border: 0.04rem solid #b5b5b5;
          border-radius: 50%;
          background: #fff;
          img {
            width: 1rem;
            height: 1rem;
          }
        }
        h4 {
          opacity: 1;
          font-size: 0.8rem;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #4279db;
          margin-bottom: 0.67rem;
          margin-top: 0.3rem;
        }
        p {
          opacity: 1;
          font-size: 0.6rem;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #333333;
          line-height: 1rem;
          text-indent: 2em;
        }
      }
      .right {
        margin: 0.82rem auto 0;
        width: 80%;
        height: 11rem;
        padding: 1.3rem 0.6rem;
        background: #ffffff;
        border: 0.03rem solid #b5b5b5;
        border-radius: 0.4rem;
        box-sizing: border-box;
        position: relative;
        top: 0.82rem;
        .twoImg {
          width: 2rem;
          height: 2rem;
          position: absolute;
          line-height: 2.4rem;
          text-align: center;
          top: -1rem;
          left: 5.8rem;
          border: 0.04rem solid #b5b5b5;
          border-radius: 50%;
          background: #fff;
          img {
            width: 1rem;
            height: 1rem;
          }
        }
        h4 {
          opacity: 1;
          font-size: 0.8rem;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #4279db;
          margin-bottom: 0.67rem;
          text-align: center;
          margin-top: 0.5rem;
        }
        p {
          opacity: 1;
          font-size: 0.6rem;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #333333;
          line-height: 1rem;
          text-indent: 2em;
          position: absolute;
        }
      }
    }
    .three {
      margin-left: 0.36rem;
      margin-bottom: 0.6rem;
      .biaotiTwo {
        width: 100%;
        height: 1.66rem;
        position: relative;
      }
    }
    .four {
      width: 100%;
      // height: 3.7rem;
      margin-bottom: 1.07rem;
      .fourLeft {
        width: 100%;
        height: 6.96rem;
        opacity: 1;
        font-size: 0.7rem;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #231815;
        text-indent: 2em;
        line-height: 1rem;
      }
      .fourRight {
        width: 100%;
        height: 13rem;
        opacity: 1;
        background: url("../../assets/img/专项培训/f23e1d3ef7e54005ac01a02784ec74f4@3x.png")
          0 0 no-repeat;
        background-size: 100%;
      }
    }
  }
}
.blue {
  display: block;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background-color: #3781e1;
  position: absolute;
  left: -0.5rem;
  top: 0.4rem;
}
h2 {
  opacity: 1;
  font-size: 0.8rem;
  font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
  font-weight: 700;
  text-align: justifyLeft;
  color: #231815;
  margin-left: 0.5rem;
}
</style>
